import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PaginationModel } from '../../models/pagination-model';

@Component({
  styleUrls: ['./cm-pagination.component.scss'],
  selector: 'app-cm-pagination', 
  templateUrl: './cm-pagination.component.html',
})
export class CMPaginationComponent implements OnInit {
    groupPages: number[] = [];
    pages: number[] = [];
    @Input() isBusy: boolean = false;
    @Input() paginationDetails$ = new BehaviorSubject<PaginationModel>({
        currentpage: 1,
        rowsperpage: 10,
    } as PaginationModel);
    @Output() requestPageEmitter = new EventEmitter<number>();
    @Input() public paginationDetails: PaginationModel;

    constructor() {
        this.paginationDetails = {
            currentpage: 1,
            rowsperpage: 10,
        } as PaginationModel;
        this.paginationDetails$ = new BehaviorSubject<PaginationModel>(this.paginationDetails);
    }

    ngOnInit(): void {
        this.paginationDetails$.subscribe((pageModel: PaginationModel) => { 
            this.pages = [];
            this.groupPages = [];
            for (var i = 1; i <= pageModel.totalPages; i++) {
                this.pages.push(i);
                if (this.groupPages.length < 10) {
                    this.groupPages.push(i);
                }
            }
            this.paginationDetails = pageModel;
            this.setGroupedPage(this.paginationDetails.currentpage);
        });
    }

    setGroupedPage(page: number) {
        this.groupPages = [];
        if (this.paginationDetails) {
            const start = (Math.floor((page -1) / this.paginationDetails.rowsperpage) * this.paginationDetails.rowsperpage) + 1;
            let finish = start + (this.paginationDetails.rowsperpage) - 1;
            finish = this.paginationDetails.totalPages < finish ? this.paginationDetails.totalPages : finish;
            for (var i = start; i <= finish; i++) {
                this.groupPages.push(i);
            }
        }
    }

    goToPage(page: number) {
        if (this.paginationDetails) {
            if (this.paginationDetails.currentpage != page) {
                this.requestPageEmitter.emit(page);
            }
        }
    }
}
